import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { BaseItemComponent } from '../base-item/base-item.component';
import { CartItem } from '../../../models/cart-item.model';

@Component({
  selector: 'usb-insurance-item',
  templateUrl: './insurance-item.component.html',
  styleUrls: ['./insurance-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InsuranceItemComponent extends BaseItemComponent {
  @Input() item: any;
  @Input() clientsSettingAppBooking: any;
}
